module.exports = __webpack_public_path__ + "static/media/cart-new-mobile.e890e44e.png";